import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { REG_EX, SVGPathMap, StorageHelper, Utils } from '@app/_helpers';
import { ConfigurationService, NgxToastrService } from '@app/_shared/providers';
import { EMAIL_UPDATED, OTP_INVALID, OTP_SENT } from '@app/_shared/strings';
import { ControlErrorMatcher } from '@app/app.models';
import { AuthService } from '@app/modules/auth';
import { UserDetails } from '@app/modules/trading/modules/mb-plans/providers/mb-plans.interface';
import { MbPlansService } from '@app/modules/trading/modules/mb-plans/providers/mb-plans.service';
import { PersonalDetailsService } from '@app/modules/trading/modules/profile/providers/personal-details/personal-details.service';
import { OtpInputComponent } from '../otp-input/otp-input.component';

@Component({
  selector: 'app-email-communication-popup',
  templateUrl: './email-communication-popup.component.html',
  styleUrls: ['./email-communication-popup.component.scss']
})
export class EmailCommunicationPopupComponent implements OnInit, AfterViewInit {
  emailFormControl: UntypedFormControl = new UntypedFormControl(null, [Validators.required, Validators.pattern(REG_EX.spaceNotAllowed), Utils.emailValidator()]);
  @ViewChild('emailRef', { static: false }) emailRef: ElementRef;
  @ViewChild('emailOtpInput') OtpInputComponent: OtpInputComponent;
  loading: boolean = false;
  isEmailVerified: boolean = false;
  isOtpSent: boolean = false;
  errorMatcher: ControlErrorMatcher = new ControlErrorMatcher();
  currentEmail: string = StorageHelper.emailCommunicationId;
  personalDetails: UserDetails;
  timer: number = this.configService.OTP_EXPIRE_TIME;
  timerIntervalRef: any;
  timerEnabled: boolean = false;
  displayTimer: string;
  utrade_logo = SVGPathMap.utrade_logo;

  constructor(
    private configService: ConfigurationService,
    private dialogRef: MatDialogRef<EmailCommunicationPopupComponent>,
    private authService: AuthService,
    private snackBar: NgxToastrService,
    private personalDetailsService: PersonalDetailsService,
    private mbPlansService: MbPlansService,
  ) { }

  ngOnInit(): void {
    this.loading = true;
    this.mbPlansService.getUserDetails().subscribe((response) => {
      this.personalDetails = response;
      this.loading = false;
    }, (_) => {
      this.loading = false;
    });
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      (document.activeElement as HTMLElement).blur();
    }, 1000)
  }

  verifyOTP() {
    if (!this.OtpInputComponent.otpForm.valid) {
      return;
    }
    this.loading = true;
    this.authService.verifyEmailOtp(this.emailFormControl.value, this.OtpInputComponent.getOtp()).subscribe((response) => {
      if (!response.isValidOTP) {
        this.isEmailVerified = false;
        if (response.status === "error" && response.message) {
          this.snackBar.simpleCustomToaster(response.message);
          this.loading = false;
        } else {
          this.snackBar.simpleCustomToaster(OTP_INVALID);
        }
      } else {
        this.isEmailVerified = true;
        this.updatePersonalDetails();
      }
      this.loading = false;
    }, _ => {
      this.loading = false;
    })
  }

  resendOTP() {
    if (!this.timerEnabled) {
      return;
    }
    this.loading = true;
    this.authService.sendEmailOTP(this.personalDetails.phone, this.emailFormControl.value).subscribe((res) => {
      this.loading = false;
      if (res.status === "success") {
        this.snackBar.simpleCustomToaster(OTP_SENT);
        this.timerEnabled = false;
        this.timer = this.configService.OTP_EXPIRE_TIME;
        this.timerInit();
        this.OtpInputComponent.otpForm.reset();
      } else {
        this.snackBar.simpleCustomToaster(res.message);
      }
    })
  }

  verifyEmail() {
    if (this.emailFormControl.invalid) {
      this.emailFormControl.markAsTouched();
      return;
    }
    this.loading = true;
    setTimeout(() => {
      this.loading = false;
    }, 3000);

    this.loading = true;
    this.authService.sendEmailOTP(this.personalDetails.phone, this.emailFormControl.value).subscribe((response) => {
      if (response.status === "success") {
        this.isOtpSent = true;
        this.timerEnabled = false;
        this.timer = this.configService.OTP_EXPIRE_TIME;
        this.timerInit();
      } else {
        this.snackBar.simpleCustomToaster(response.message);
      }
      this.loading = false;
    }, _ => {
      this.loading = false;
    });


  }

  updatePersonalDetails() {
    this.personalDetails.email = this.emailFormControl.value;
    this.personalDetailsService.updatePersonalDetails(this.personalDetails).subscribe((response) => {
      this.snackBar.simpleCustomToaster(EMAIL_UPDATED);
      StorageHelper.emailCommunication = null;
      this.mbPlansService.getUserDetails(true).subscribe();
      this.dialogRef.close();
    });
  }

  changeEmail() {
    this.isEmailVerified = false;
    this.isOtpSent = false;
    this.emailFormControl.reset();
    this.emailFormControl.markAsUntouched();
    this.timerReset();
    setTimeout(() => {
      this.emailRef.nativeElement.focus();
    }, 500)
  }

  timerReset() {
    this.timer = this.configService.OTP_EXPIRE_TIME;
    clearInterval(this.timerIntervalRef);
    this.timerDec();
  }

  closeDialog() {
    this.authService.verifyEmailOtp(this.currentEmail, '', true).subscribe((res) => {
    });
    StorageHelper.emailCommunication = null;
    this.mbPlansService.getUserDetails(true).subscribe();
    this.dialogRef.close();
  }

  maskEmail(): string {
    let email = this.emailFormControl.value;
    const atIndex = email.indexOf('@');
    if (atIndex > 3) {
      const prefix = email.slice(0, 5);
      const masked = email.slice(5, atIndex).replace(/./g, '*');
      return prefix + masked + '@' + email.slice(atIndex + 1);
    }
    return email;
  }

  timerDec() {
    this.timer--;
    this.displayTimer = ('0' + (this.timer % 60)).slice(-2).toString() + ' sec';
    if (this.timer === 0) {
      this.timerEnabled = true;
      clearInterval(this.timerIntervalRef);
    }
  }

  timerInit() {
    this.timerIntervalRef = setInterval(() => {
      this.timerDec();
    }, 1000);
    this.timerDec();
  }


}
